<!-- title -->
<template>
  <div id='title'>
    <h2>
      <slot></slot>
    </h2>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  components: {},
  created () { },
  methods: {}
}
</script>
<style scoped lang='scss'>
#title {
  text-align: left;
  h2 {
    font-size: 20px;
    &::before {
      display: inline-block;
      content: ' ';
      width: 4px;
      height: 16px;
      background-color: #44a2fe;
      border-radius: 3px;
      margin-right: 10px;
    }
  }
}
</style>
